import InvictusLogo from "../assets/Invictus_logo.png";
import AakashLogo from "../assets/AakashLogo.png";
import callDialer from "../assets/call.png";
import ScolarshipLogo from "../assets/ScolarshipLogo";
import SubjectWiseAnalysisLogo from "../assets/SubjectWiseAnalysisLogo";
import AcademicLogo from "../assets/AcademicLogo";
import styles from "../components/invictusresult.module.css"

export default function InvictusResultPage({ Response, isQualified }) {
  const qr = Response.centerData.center_detail.qr_code;
  const eligibleForScholarship = Response.scholarship.remarks;

  const studentDetails = [
    [
      "Roll No. / PSID",
      `${Response.profile.roll_number} / ${Response?.profile?.psId || "NA"}`,
    ],
    ["Name of the Candidate", Response.profile.name],
    ["Father's Name", Response.profile.father_name],
    [
      "Stream / Class Opted",
      `${Response.profile.stream === "SOF"
        ? "Foundation"
        : Response.profile.stream === "SOM"
          ? "Medical"
          : "Engineering"
      } / ${Response.profile.class_opted}`,
    ],
    ["Percentage Marks", Response.percentage + "%"],
    [
      "Invictus Result",
      isQualified
        ? `Qualified* | ${eligibleForScholarship}`
        : "Not Eligible. * However, eligible for other admission cum scholarship opportunities",
    ],
  ];

  const renderStudentDetail = (item, index) => (
    <div
      className="col d-flex align-items-center flex-row py-2"
      style={{
        maxWidth: "100%",
        backgroundColor: index % 2 === 0 ? "#FFFFFF" : "",
        padding: "0px 40px 0 60px"
      }}
      key={index}
    >
      <span className="text-start ms-5 fw-500 w-50" style={{ color: "#5B5B5B", fontFamily: "Outfit-Medium", fontSize: "22px" }}>{item[0]}</span>
      <div className="mx-2">:</div>
      <span className={`ms-5 text-start w-50 ${index == 0 ? "fw-bold" : "500"}`} style={{ color: "#5B5B5B", fontFamily: "Outfit-Medium", fontSize: "22px" }}>
        {item[1]}
      </span>
    </div>
  );

  const renderContactNumber = (number, index, numbers) => (
    <div key={index} className="col my-2">
      {index % 2 === 0 && index + 1 < numbers.length ? `${number}, ` : number}
    </div>
  );

  const renderCircleCard = (Logo, text, bgColor, content, subtext) => (
    <div className="d-flex flex-column align-items-center">
      <div
        className="position-relative rounded-circle d-flex flex-column justify-content-center align-items-center"
        style={{
          backgroundColor: bgColor,
          width: "250px",
          height: "250px",
        }}
      >
        <div
          className="position-absolute rounded-circle fs-2 text-center"
          style={{
            width: "50px",
            height: "50px",
            left: 0,
            top: 30,
            border: "1px solid #FFFFFF",
            backgroundColor: "#F6F6F6",
            color: "#926CAC",
          }}
        >
          {content}
        </div>
        <Logo
          style={{
            width: text === "ACADEMIC COUNSELLING" ? "75px" : "50px",
            height: text === "ACADEMIC COUNSELLING" ? "75px" : "50px",
            marginBottom: "10px",
          }}
        />
        <p className="text-center mb-0" style={{ fontSize: "25px" }}>
          {text}
        </p>
        {subtext && (
          <p className="text-center mt-0" style={{ fontSize: "10px" }}>
            {subtext}
          </p>
        )}
      </div>
    </div>
  );
  return (
    <div className="p-4 d-flex flex-column gap-4" style={{ height: "100%" }}>
      <div
        className="d-flex justify-content-between "
        style={{ paddingBottom: "20px" }}
      >
        <div className={`${styles.invictus_logo} bg-Invictus-blue`}>
          <img
            src={InvictusLogo}
            className="img-fluid"
            // style={{ width: "350px", height: "150px" }}
            alt="iacst-logo"
          />
        </div>
        <img
          src={AakashLogo}
          className="img-fluid align-self-center"
          style={{ width: "200px", height: "100px" }}
          alt="aakash-logo"
        />
      </div>
      {!isQualified ? (
        <p className="text-start" style={{ color: "#3A3A3A", fontSize: "20px" }}>{eligibleForScholarship}</p>
      ) : null}
      <div
        className="text-center py-4 px-3 mb-4"
        style={{ backgroundColor: "#EBEDEC", borderRadius: "10px" }}
      >
        {isQualified ? (
          <>
            <h1 style={{ color: "#85438B", fontWeight: "bold" }}>
              Congratulations!
            </h1>
            <h2 style={{ fontWeight: "bold", fontSize: "33px", color: '#3A3A3A' }}>
              You have qualified for {Response?.scholarship?.tuitionFee || 0}%
              scholarship* based on your IAT Score
            </h2>
            <div
              className="d-flex justify-content-center text-white p-1 mb-2"
              style={{ backgroundColor: "#029FE1", borderRadius: "10px" }}
            >
              <h3 className="mt-1" style={{ fontSize: "34px", color: '#FFFFFF', fontWeight: 700 }}>
                IAT Scholarship is valid for <span style={{ color: '#FFE500' }}>One Month</span> from the date of exam.
              </h3>
            </div>
          </>
        ) : (
          null
        )}


        <div
          className="d-flex text-start justify-content-between py-3 mt-0 px-4"
          style={{ backgroundColor: "#D0E5EB", borderRadius: "10px" }}
        >
          <div className="d-flex flex-column pe-4" style={{ minHeight: "250px" }}>
            <span className="text-start fw-bold fs-4 mb-3">Branch Address:</span>
            <span className="text-start font-size-md fw-bold">
              {Response.centerData.center_detail.address}
            </span>
            <div className="my-4" style={{ border: "1px solid rgb(82, 80, 80)" }} />
            <span className="text-start fw-bold fs-4">
              Branch Contact Details:
            </span>
            <div
              className="row row-cols-2"
              style={{ fontWeight: "bold", maxWidth: "350px" }}
            >
              {Response.centerData.center_detail.contact_numbers.map(
                (number, index) =>
                  renderContactNumber(
                    number,
                    index,
                    Response.centerData.center_detail.contact_numbers
                  )
              )}
            </div>
          </div>

          <div
            className="d-flex flex-column bg-white pt-2"
            style={{ borderRadius: "10px", maxWidth: "220px" }}
          >
            <img
              className="img-fluid w-75 h-75 mx-auto"
              src={qr}
              alt="qr-code"
            />
            <span className="text-center text-black p-2 lh-sm">
              Scan the QR code and get the branch location in your Google Maps
            </span>
          </div>
        </div>
      </div>

      <div
        className="d-flex justify-content-center flex-column"
        style={{ backgroundColor: "#E6E6E6", borderRadius: "10px" }}
      >
        <div
          className="d-flex align-items-center"
          style={{ backgroundColor: "#0F4C8C", borderRadius: "10px 10px 0 0" }}
        >
          <p className="text-center fs-2 fw-bold text-white w-100 m-0">
            RESULT
          </p>
        </div>
        <p
          className="text-center  fw-bold w-100 m-0"
          style={{ backgroundColor: "#E6E6E6", border: "2px dashed #C5C6C6", color: "#434242", fontSize: "27px" }}
        >
          FOR CLASS {Response.profile.class_studying} STUDYING STUDENT
        </p>
        <div
          style={{
            border: "2px dotted #C5C6C6",
            borderTop: 0,
            borderRadius: "0 10px 0",
          }}
        >
          {studentDetails.map((item, index) =>
            renderStudentDetail(item, index)
          )}
        </div>
      </div>

      <p className="text-start font-size-xl fw-600" style={{ marginBottom: "0" }}>
        *The secured scholarship is applicable on Classroom Courses
      </p>
      <p className="text-start" style={{ marginTop: "0" }}>
        **By viewing this result, you (or your parent/guardian, if you are under 18) hereby provide consent to AESL to contact you via phone, email, SMS, or other
        communication channels for the purpose of sharing information, updates, and promotional material related to our services until 31st August 2026. You
        have the right to withdraw your consent at any time by contacting us at care@aesl.in.
      </p>
      <div className="d-flex flex-column" style={{ paddingBottom: "40px" }}>
        <div
          className="py-2 text-center fs-2 fw-bold"
          style={{
            backgroundColor: "#784C90",
            color: "#FFFFFF",
            borderRadius: "10px 10px 0 0",
            minWidth: '160px'
          }}
        >
          PLEASE VISIT YOUR NEAREST BRANCH OR CALL FOR
        </div>
        <div
          className="d-flex justify-content-around pt-4 pb-4"
          style={{
            background: "#F3F3F3",
            border: "2px dashed #C5C6C6",
            borderTop: "none",
            minHeight: "110%",
          }}
        >
          {renderCircleCard(
            ScolarshipLogo,
            "SCHOLARSHIP DETAILS",
            "#FCF3DA",
            "1",
            isQualified ? null : "(for Direct Admissions)"
          )}
          {renderCircleCard(
            SubjectWiseAnalysisLogo,
            "SUBJECT WISE ANALYSIS",
            "#D0E5EB",
            "2"
          )}
          {renderCircleCard(
            AcademicLogo,
            "ACADEMIC COUNSELLING",
            "#FCF3DA",
            "3"
          )}
        </div>
      </div>
      <div className="d-flex justify-content-end" style={{ marginTop: "auto" }}>
        <div className="border-top d-flex gap-4 p-2 mt-5 justify-content-end">
          <div className="d-flex flex-column mt-1">
            <div className="d-flex align-items-center">

              <p className="mb-0 text-end"><span className="fw-bold me-1 ">Corporate Office:</span> 3rd Floor, Incuspaze Campus – 2, Plot No. 13,<br />Sector – 18, Udyog Vihar, Gurugram, Haryana - 122015</p>

            </div>
            <div className="text-end">
              <span className="fw-bold">Ph.:</span> (011) 47623456
              <span className="fw-bold">| E-mail:</span> care@aesl.in
            </div>
          </div>
          <div
            style={{
              width: "1px",
              height: "50px",
              marginTop: "5px",
              backgroundColor: "#000000",
            }}
          />
          <div className="d-flex align-items-center gap-3">
            <img
              src={callDialer}
              className="img-fluid"
              style={{ width: "50px", height: "50px" }}
              alt="call-dialer"
            />
            <div className="d-flex flex-column align-items-start">
              <p className="fw-bold mb-0">TOLL FREE NUMBER</p>
              <p className="fs-3 fw-bold mb-0">1800-102-2727</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
